import AnalyticsEvent from '../analytics-event';
import { EoriWarningInteraction } from '../segment-ecommerce-types';

export class EoriAppliedForEvent extends AnalyticsEvent {
  public readonly name = 'EORI Warning Clicked apply';

  constructor(public readonly properties: EoriWarningInteraction) {
    super();
  }
}
